/**
 * Contrato y helpers del video del ATR como ARCHIVO (backend: modules/atrVideos). Espejo de lo que
 * devuelve `GET /api/claims/:id/atr-videos` (entrada `video`) y `POST /api/atr-videos/:id/share`.
 */
export type AtrVideoShare = { url: string; title: string | null; createdAt: string | null; byName: string | null; views: number; lastViewedAt: string | null };
export type AtrVideoDTO = {
  id: string;
  /** 'atr' (el ATR del claim) o 'info' (video informativo de la visita, mig 0442). */
  kind: 'atr' | 'info';
  claimId: string | null; appointmentId: string | null; fileId: string | null;
  fileName: string; mime: string; sizeBytes: number | null; durationMs: number | null; width: number | null; height: number | null;
  /** Lo que olfateó el teléfono antes de subir: 'hevc' | 'h264' | 'unknown' | null. */
  codec: string | null;
  uploadedBy: string | null; createdAt: string; readyAt: string | null;
  /** URL interna (`/api/atr-videos/<id>/media`): office+ y el inspector que lo subió. */
  mediaUrl: string; title: string | null;
  /** null = sin link público (o revocado). */
  share: AtrVideoShare | null;
};

/** El id del video si la URL es la interna de este módulo (absoluta o relativa); null si es YouTube u otra cosa. */
export function atrMediaId(url: string | null | undefined): string | null {
  const m = /\/api\/atr-videos\/(\d{1,18})\/media(?:[?#]|$)/.exec(url ?? '');
  return m ? m[1]! : null;
}

export function fmtBytes(bytes: number | null | undefined): string {
  if (bytes == null || !Number.isFinite(bytes)) return '';
  if (bytes >= 1024 ** 3) return `${(bytes / 1024 ** 3).toFixed(1)} GB`;
  if (bytes >= 1024 ** 2) return `${Math.round(bytes / 1024 ** 2)} MB`;
  return `${Math.max(1, Math.round(bytes / 1024))} KB`;
}

/** "6:32" · "1:02:05". */
export function fmtDuration(ms: number | null | undefined): string {
  if (ms == null || !Number.isFinite(ms) || ms <= 0) return '';
  const s = Math.round(ms / 1000);
  const h = Math.floor(s / 3600); const m = Math.floor((s % 3600) / 60); const ss = s % 60;
  return h ? `${h}:${String(m).padStart(2, '0')}:${String(ss).padStart(2, '0')}` : `${m}:${String(ss).padStart(2, '0')}`;
}
